module.exports = __webpack_public_path__ + "static/media/Twitter_Logo_White.03401658.svg";